// extracted by mini-css-extract-plugin
export default {"navMenu":"HeaderMenu_navMenu__l+LHl","navItem":"HeaderMenu_navItem__9Z85T","link":"HeaderMenu_link__3lSUG","svg":"HeaderMenu_svg__cjrxZ"};